const SERVER_URL = process.env.REACT_APP_ADMIAPI_URL

const apiroutes  = {
      'auth' : {
         'token' : `${SERVER_URL}/token`,
      },
      'tenants' : {
         'get' : `${SERVER_URL}/tenants/get`,
      },
      'contactus' : {
         'getall' : `${SERVER_URL}/contactus/get`,
         'reply':  `${SERVER_URL}/contactus`,
      }
}


export const getAuthEndpoint = () => {
  return `${SERVER_URL}/api/auth/token`
}


export const getTenantDetailEndpoint = (id) => {
  return `${SERVER_URL}/tenants/${id}`
}


export const getTenantListEndpoint = () => {
  return `${SERVER_URL}/tenants/`
}

export const getRegistrationRequestListEndpoint = () => {
  return `${SERVER_URL}/register/`
}

export const getSetupTenantEndpoint = () => {
   return `${SERVER_URL}/tenant/setup`
}


export const getSendEmailToTenantEndpoint = (tenant_id) => {
   return `${SERVER_URL}/action/send_email_to_tenant`
}


export const getActivityLogEndpoint = () => {
   return `${SERVER_URL}/activitylog`
}



class RestAPIRoutes {

  static get(model , action , id) {
    return apiroutes[model][action]
  }
}

export default RestAPIRoutes;
